import type { PropsWithChildren } from "react";

import { ChevronDown } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Option } from "@similarweb/ui-components";
import type { FlexProps } from "@similarweb/ui-components/foundations";
import { Flex, TruncatedText } from "@similarweb/ui-components/foundations";

const { carbon, red } = colorsPalettes;

type DomainComboboxTriggerProps = {
    label?: string;
    favicon?: string;
    placeholder: string;
    isInvalid?: boolean;
};

export const DomainComboboxTrigger = ({
    label,
    favicon,
    placeholder,
    isInvalid,
    ...props
}: PropsWithChildren<DomainComboboxTriggerProps> & FlexProps) => {
    const hasValue = Boolean(label);
    const borderColor = isInvalid ? red["400_P"] : carbon[200];

    return (
        <Flex
            as="button"
            type="button"
            width="100%"
            height="36px"
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            padding="0 12px"
            borderRadius="4px"
            background={carbon[0]}
            border={`1px solid ${borderColor}`}
            whenHover={{
                border: `1px solid ${isInvalid ? red["400_P"] : carbon[300]}`,
            }}
            {...props}
        >
            <Flex
                alignItems="center"
                gap="8px"
                minWidth="0"
            >
                {favicon ? <Option.Favicon src={favicon} /> : null}
                <TruncatedText
                    fontVariant="listItem1"
                    color={hasValue ? carbon[500] : carbon[300]}
                    textAlign="start"
                >
                    {label || placeholder}
                </TruncatedText>
            </Flex>
            <ChevronDown
                size="sm"
                color={carbon[300]}
            />
        </Flex>
    );
};
